class DetailsDisclosure extends HTMLElement {
	constructor() {
		super();
		this.mainDetailsToggle = this.querySelector('details');

		this.addEventListener('keyup', this.onKeyUp);
		document.addEventListener('click', this.onFocusOut.bind(this));

		// Close on mouse leave (for megamenus)
		this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
	}

	onMouseLeave(e) {
		// Small delay to allow moving to submenus
		setTimeout(() => {
			if (!this.matches(':hover')) {
				this.mainDetailsToggle.removeAttribute('open');
			}
		}, 100);
	}

	onKeyUp(event) {
		if (event.code.toUpperCase() !== 'ESCAPE') return;

		const openDetailsElement = event.target.closest('details[open]');
		if (!openDetailsElement) return;

		const summaryElement = openDetailsElement.querySelector('summary');
		openDetailsElement.removeAttribute('open');
		summaryElement.focus();
	}

	onFocusOut(e) {
		const withBoundaries = e.composedPath().includes(this.mainDetailsToggle);

		if (!withBoundaries) {
			this.mainDetailsToggle.removeAttribute('open');
		}
	}

	close() {
		this.mainDetailsToggle.removeAttribute('open')
	}
}

customElements.define('details-disclosure', DetailsDisclosure);
